import { render, staticRenderFns } from "./OnlineServiceList.vue?vue&type=template&id=40a9e784&scoped=true"
import script from "./OnlineServiceList.vue?vue&type=script&lang=js"
export * from "./OnlineServiceList.vue?vue&type=script&lang=js"
import style0 from "./OnlineServiceList.vue?vue&type=style&index=0&id=40a9e784&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a9e784",
  null
  
)

export default component.exports